// firebase/config.js - Complete version with Storage
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore, initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; // Add this import

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyABBa7MqV-byNcJp-5kZTFaL53e2E8srtA",
  authDomain: "indobrand-1e09e.firebaseapp.com",
  projectId: "indobrand-1e09e",
  storageBucket: "indobrand-1e09e.firebasestorage.app", // Updated to correct bucket name
  messagingSenderId: "533367867813",
  appId: "1:533367867813:web:ee410ac2128f1cabf0404c",
  measurementId: "G-PJYN5GQ94K"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
// Use optimized Firestore settings for performance
const db = initializeFirestore(app, {
  experimentalForceLongPolling: false, // Disable long-polling for better performance
  useFetchStreams: true, // Enable fetch streams for faster loading
  ignoreUndefinedProperties: true, // Ignore undefined properties
  cacheSizeBytes: 40000000 // 40MB cache for better performance
});
const storage = getStorage(app); // Initialize Firebase Storage

export { app, analytics, auth, db, storage };